"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./default.component"));
__export(require("./doubleclickzoom.component"));
__export(require("./draganddrop.component"));
__export(require("./dragbox.component"));
__export(require("./dragpan.component"));
__export(require("./dragrotate.component"));
__export(require("./dragrotateandzoom.component"));
__export(require("./dragzoom.component"));
__export(require("./mousewheelzoom.component"));
__export(require("./pinchzoom.component"));
__export(require("./draw.component"));
__export(require("./select.component"));
__export(require("./translate.component"));
__export(require("./modify.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/interactions/index.js
// module id = 1081
// module chunks = 3